module.exports = {
  /**
   * 项目名称
   */
  projectTitle: "西山居app分发平台",
  /**
   * 项目名称
   */
  projectName: "TcMicroTako",
  /**
   * 当前的系统模式是否是开发模式
   * 影响请求权限校验机制*/
  isDevelopMode: false,
  /**
   * 开发模式下的请求校验服务地址
   */
  developVerifyTicketUrl: "http://localhost:9008/api/verifyTicket",
  /**
   * 布局模式 horizontal（菜单栏在上部） vertical （菜单栏在左边） none（不用默认布局）
   */
  layoutMode: "vertical",
  /**
   * SSO服务地址*/
  ssoServerUrl: "https://internet-xsjsso.seasungame.com/api-xsjsso",

  /**
   * 是否启用事件总线（因为事件总线往往不是必须的，且容易影响性能所以不在必须的情况下不启动）
   */
  useBus: true,
  /**
   * 埋点数据上报的地址 (需要联系技术中心 获取地址)
   */
  logsServerUrl: "/client/push/app_200001006/",
  /**
   *  埋点上传的表名
   */
  logsTableName: "tc_vue_base_template",

  /**
   *  是否使用mock
   */
  useMock: true,

  /**
   *  是否启用菜单权限控制
   */
  userPrivileges: true,
  /**
   * main服务地址(登出后再登录的默认地址)*/
  mainServerUrl: "https://tako.seasungame.com",

  /**
   * tako服务地址*/
  takoServiceBase: "https://tako.seasungame.com",

  /**
   * 分页数
   */
  MaxPageCount: 3000,

};
